import { FMSInterface, FMSType } from "@swivl-mono/types";
import { Input, MultiPartSlider, Select, Switch, TextArea } from "@swivl-mono/ui";

interface Props {
  fms?: FMSInterface;
  onSwitch(name, value): void;
  onBlur();
  onDataChange(e: any);
  onSliderChange(e: any);
}

export const FMSSettingsColumn = (props: Props) => {
  const { fms, onBlur, onSwitch, onDataChange, onSliderChange } = props;
  if (!fms) {
    return null;
  }

  const data = fms.data || {};
  const sliderValues = [
    { label: "Small", color: "#FFA900", value: data.smallMaxSize || 100 },
    { label: "Medium", color: "#F67902", value: data.mediumMaxSize || 200 },
    { label: "Large", color: "#00CABE", value: data.largeMaxSize || 300 },
    { label: "Extra Large", color: "#413B38", value: 400 }
  ];

  let priceField;

  const onSwitchChange = (event: any) => {
    const { name, checked } = event.target;
    onSwitch(name, checked);
  };

  if (fms.type === FMSType.SiteLink) {
    priceField = (
      <div className="siteSection">
        <h3 className="text-lg font-semibold text-grey-800">Price Field</h3>
        <Select
          name="priceField"
          selectedValues={data.priceField ? [data.priceField] : []}
          onChange={(vals) => onDataChange({ target: { name: "priceField", value: vals[0] } } as any)}
          hideClear
          options={[
            { label: "Web Rate", value: "dcWebRate" },
            { label: "Push Rate", value: "dcPushRate" },
            { label: "Preferred Rate", value: "dcPreferredRate" },
            { label: "Board Rate", value: "dcBoardRate" },
            { label: "Std Rate", value: "dcStdRate" }
          ]}
        />

        <div className="SwitchWithLabel">
          <Switch on={data.includeTax} name="includeTax" onChange={onSwitchChange} label={"Include Tax in Price"} />
        </div>
      </div>
    );
  }

  return (
    <div className="fmsValues">
      <div className="siteSection">
        <h2 className="text-2xl text-grey-800">Node & Chat Settings</h2>
        <h3 className="text-lg font-semibold text-grey-800">Inventory</h3>
        Turning this option on will show the lowest price on an available unit type
        <div className="SwitchWithLabel">
          <Switch on={data.showPrice} name="showPrice" onChange={onSwitchChange} label={"Show Price"} />
        </div>
        <h3 className="text-lg font-semibold text-grey-800">Floor</h3>
        <div className="SwitchWithLabel">
          <Switch on={data.showFloor} name="showFloor" onChange={onSwitchChange} label={"Show Floor"} />
        </div>
      </div>
      {priceField}
      <div className="siteSection">
        <Input
          label="Action Button"
          helperText="This is the text that appears on the button for a unit inside the inventory carousel"
          onChange={onDataChange}
          name="actionButton"
          value={data.actionButton}
          onBlur={onBlur}
        />
      </div>
      <div className="siteSection">
        <h3 className="text-lg font-semibold text-grey-800">Sizing</h3>
        Move the sliders to set the maximum sq. ft for each size
        <div className="sliderContainer">
          <MultiPartSlider max={400} min={0} values={sliderValues} setValues={onSliderChange} finishedSettingValues={onBlur} />
        </div>
      </div>
      <div className="siteSection">
        <h3 className="text-lg font-semibold text-grey-800">Descriptions</h3>
        SMALL
        <TextArea onChange={onDataChange} name="sizeSmallDescription" value={data.sizeSmallDescription} onBlur={onBlur} />
        MEDIUM
        <TextArea onChange={onDataChange} name="sizeMediumDescription" value={data.sizeMediumDescription} onBlur={onBlur} />
        LARGE
        <TextArea onChange={onDataChange} name="sizeLargeDescription" value={data.sizeLargeDescription} onBlur={onBlur} />
        EXTRA LARGE
        <TextArea onChange={onDataChange} name="sizeExtraLargeDescription" value={data.sizeExtraLargeDescription} onBlur={onBlur} />
        PARKING
        <TextArea onChange={onDataChange} name="sizeParkingDescription" value={data.sizeParkingDescription} onBlur={onBlur} />
      </div>
    </div>
  );
};
